import * as React from 'react';
import './Toast.css'
import { Toast } from './model'

export type ValueProps = Toast

export type Props = ValueProps

const defaultKind = 'info'

export const MonitoringToast = (props: Props) => {
  return (
    <div
      data-test-id={props.testId ? props.testId : 'monitoring-toast'}
      className={`monitoring-toast ${props.kind ? props.kind : defaultKind}`}
    >
      {
        props.title &&
        <div className="monitoring-toast-title" data-test-id={props.testId ? `${props.testId}-title` : 'monitoring-toast-title'}>
          {props.title}
        </div>
      }
      {props.children &&
      <div className="monitoring-toast-children" data-test-id={props.testId ? `${props.testId}-children` : 'monitoring-toast-children'}>
        {props.children}
      </div>
      }
    </div>
  );
}
